import { useCallback, useRef } from 'react';
import { reportsApi } from '../../../services/reportsApi';

/** Same customer compact snapshot signing freezes. HTML record, not a live dashboard. */
export const SAFETY_SCAN_PREVIEW_FACE = 'customer_compact' as const;

type PreviewCache = {
  reportId: string;
};

export function useSafetyScanRecordPreview(reportId?: string | null) {
  const cacheRef = useRef<PreviewCache | null>(null);

  const preview = useCallback(async () => {
    const id = String(reportId || '').trim();
    if (!id) return;
    const html = await reportsApi.getCustomerSafetyScanHtml(id);
    const popup = window.open('', '_blank');
    if (!popup) return;
    popup.document.open();
    popup.document.write(html);
    popup.document.close();
    cacheRef.current = { reportId: id };
  }, [reportId]);

  return { preview };
}
